module.exports = __webpack_public_path__ + "img/wero.2c7f8766.svg";